// extracted by mini-css-extract-plugin
export default {"order_table":"ManageAdmin_order_table__+7quj","header_section":"ManageAdmin_header_section__CZUyT","lists_":"ManageAdmin_lists___GeIGS"};